import { Theme, extendTheme } from "@chakra-ui/react";

const fonts: Partial<Theme["fonts"]> = {
	heading: `'Roboto', sans-serif`,
	body: `'Roboto', sans-serif`,
};

const colors: Partial<Theme["colors"]> = {
	green: {
		"50": "#effaf1",
		"100": "#d8f3db",
		"200": "#b4e6bd",
		"300": "#82d396",
		"400": "#4bb769",
		"500": "#2c9d4f",
		"600": "#1d7e3d",
		"700": "#176533",
		"800": "#15502a",
		"900": "#124224",
	},
};

// const breakpoints = {
// 	sm: "320px",
// 	md: "768px",
// 	lg: "960px",
// 	xl: "1200px",
// 	"2xl": "1536px",
// };

export const customChakraTheme = extendTheme({ fonts, colors });
